import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';
import { SupplierDto } from '../supplier.dto';
import { EdiConnectionDto } from './edi-connection.dto';
import { EdiMessageTypeDto } from './edi-message-type.dto';

export class EdiIntegrationDto extends BaseDto {
  supplierId: number;
  messageTypeId: number;
  connectionId: number;
  merchantId: number;
  enabled: boolean;
  requireOrderConfirmation: boolean;
  connection: EdiConnectionDto;
  messageType: EdiMessageTypeDto;
  supplier: SupplierDto;
  merchant?: MerchantDto;
  sendEmail?: boolean;
}
